import {HttpClient, HttpHeaders} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {BusinessContext, IBusinessPartner} from '@service-and-repairs/awpintegrationlib';
import {VehicleCampaignCollection} from '../interfaces/vehicle-campaign-collection';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  private readonly supportedHeaders: string[] = [
    'accept-encoding',
    'accept-language',
    'access_token',
    'auth-app-id',
    'auth-brands',
    'auth-buno',
    'auth-country',
    'auth-dist-partner',
    'auth-outlet',
    'auth-session',
    'authorization',
    'authscheme',
    'authtype',
    'cache-control',
    'cavors-request-id',
    'cavors-session-id',
    'content-type',
    'cookie',
    'cssl-authorization',
    'origin',
    'pragma',
    'referer',
    'user-agent',
    'x-app-authorization',
    'x-requesting-application'
  ];

  private headers: HttpHeaders = new HttpHeaders();

  constructor() {
    this.addHeadersIfSupported({
      'AuthType': 'WEN_TOKEN',
      'Content-Type': 'application/json',
      'Auth-App-Id': 'awp'
    });
  }

  getCampaigns(vin: string,
               context: BusinessContext,
               language: string,
               country: string,
               businessPartner?: IBusinessPartner): Promise<VehicleCampaignCollection> {
    this.setHeader(context, country, businessPartner);
    return new Promise((resolve, reject) => {
      this.httpClient.get(
          this.getUrl(context) + `?vin=${vin}&language=${language}&appId=awp`,
          {
            headers: this.headers,
            withCredentials: true
          }
        )
        .subscribe({
          next: (campaigns: VehicleCampaignCollection) => resolve(campaigns),
          error: reason => reject(reason)
        });
    });
  }

  private getUrl(context: BusinessContext): string {
    return '/api/air-services/technical-campaigns/' + (context === BusinessContext.B2D ? 'b2xinternet' : 'b2xintranet');
  }

  private setHeader(context: BusinessContext, country: string, businessPartner?: IBusinessPartner): void {
    this.addHeadersIfSupported({
      'AuthScheme': 'B2D'
    });

    switch (context) {
      case BusinessContext.B2D:
      case BusinessContext.B2D_INTERNAL: {
        this.addHeadersIfSupported({
          'Auth-Dist-Partner': businessPartner.getDistributionPartnerNumber(),
          'Auth-Outlet': businessPartner.getOutletNumber()
        });
        break;
      }
    }
  }

  private addHeadersIfSupported(headers: {}): void {
    Object.keys(headers).forEach(key => {
      if (this.supportedHeaders.indexOf(key.toLowerCase()) >= 0) {
        this.headers = this.headers.set(key, headers[key]);
      }
    });
  }
}
